export const environment = {
   production: true,
   dataBackendUrl: 'https://navinta-prod-backend.azurewebsites.net/api',
   oktaUri: 'https://login.draeger.com/oauth2/default',
   oktaClientId: '0oaccohk0vWgzlnKT417',
   useMyDraegerAuth: true,
   oktaScopes: 'openid profile email offline_access dcid.rights dcid.institution dcid.profile',
   oktaScopesLegacy: 'openid profile email offline_access Legacy',
   crmUrl: 'https://draeger-prod.crm4.dynamics.com/main.aspx?appid=77beae7e-f2d7-4796-bca1-0b695ad74bf7&forceUCI=1&pagetype=entitylist&etn=contact&viewid=00000000-0000-0000-00aa-000010001004&viewType=1039',
   sentryIngestUrl: 'https://deeff6352e168b64061ae3d6c0ab5b49@o4507922417975296.ingest.de.sentry.io/4508761663930449',
   sentryEnvironment: 'prod',
   googleTagManagerId: 'G-8XRP77C5Z9',
   lokaliseNavintaProjectId: 'undefined',
   lokaliseApiUrl: 'https://api.lokalise.com/api2/projects/undefined',
   lokaliseApiToken: 'undefined',
   productFruitsWorkspaceCode: 'cjoRV3Nj6wnP5lsQ',
   cantoBaseUrl: 'https://d5ujlw1eee6el.cloudfront.net',
   cantoAccountId: '886047841799',
   apiUrl: "https://ca-navinta-api-prod-gwc.whitedesert-7a62e789.germanywestcentral.azurecontainerapps.io/api",
   frontdoorUrl: "https://navinta.draeger.net",
   testInstitutionId: '',
};
